<template>
  <vs-wrapper>
    <vs-heading>Access</vs-heading>
    <vs-autocomplete
      :items="hubs"
      :value="props.accessBusinessUnitIds"
      label="Hub"
      multiselect
      :rules="[
        (items) =>
          props.accessGrantRequired && items?.length === 0 && 'One or more hubs are required',
      ]"
      @input="handleAccessUpdate({ field: 'accessBusinessUnitIds', value: $event })"
    />
  </vs-wrapper>
</template>
<script lang="ts" setup>
import { computed, onMounted } from 'vue'
import { useLocationQuery } from '@/api/locations'
import { useHubs } from '@/common/useHubs'
import { useGetAllHubsOptions, OptionDropdownItem } from '@/api/options'

const { accessibleHubs } = useHubs()
const { data: allHubsOptions } = useGetAllHubsOptions()

interface Props {
  accessGrantRequired?: boolean
  locationId?: number | null
  parentLocationId?: number | null
  accessBusinessUnitIds: string[]
}

const props = withDefaults(defineProps<Props>(), {
  accessGrantRequired: false,
  locationId: null,
  parentLocationId: null,
  accessBusinessUnitIds: () => [],
})

const emits = defineEmits(['updated'])

const { data: parentLocation } = useLocationQuery(props.parentLocationId)

const hubs = computed(() =>
  allHubsOptions.value
    ?.filter((o) => 'value' in o)
    .map((o) => o as OptionDropdownItem)
    .map((o) => {
      return {
        disabled: !(
          accessibleHubs.value?.map((h) => h.id).includes(o.value) ||
          parentLocation.value?.accessBusinessUnitIds.includes(o.value)
        ),
        ...o,
      }
    }),
)

onMounted(() => {
  const defaultHub = accessibleHubs.value.length > 0 && accessibleHubs.value[0].id

  if (props.locationId === null && defaultHub) {
    handleAccessUpdate({
      field: 'accessBusinessUnitIds',
      value: [defaultHub],
    })
  }
})

const handleAccessUpdate = (data: unknown) => {
  emits('updated', data)
}
</script>
